import { icons } from "assets";
import React, { useState } from "react";
import { RequestNewCardModal } from "Screens/debit-card/RequestNewCardModal";
import Text from "../text";
import { CardModal } from "./CardModal";
import styles from "./cards.module.css";

export const DebitCard = ({
  cardNumber,
  background = "#CBD5E1",
  expiryDate,
  style,
  classname,
  info,
  cardId
}) => {
  const [visible, setVisible] = useState(false);
  const handleVisible = () => {
    setVisible(!visible);
  };

  return (
    <Text
      tag="div"
      style={{
        background: background,
        padding: "1.5rem",
        borderRadius: "15px",
        margin: "2rem 0",
        position: "relative",
        ...style,
      }}
      className={classname ? styles.space : null}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <img src={icons.logoW} alt="Logo" style={{ width: "150px" }} />
        </div>
        {info && (
          <div
            onClick={handleVisible}
            style={{
              backgroundColor: visible && "rgba(255, 255, 255, 0.3)",
              padding: visible && ".2rem .3rem",
              borderRadius: visible && 5,
            }}
          >
            <img src={icons.threedots} alt="Logo" />
          </div>
        )}
      </div>

      <Text tag="div" style={{ paddingTop: info ? "1.5rem" : "2.4rem" }}>
        <Text style={{ color: "white" }}>{cardNumber}</Text>
        <Text
          tag="div"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Text style={{ color: "white" }}>{expiryDate}</Text>
            {info && (
              <div
                style={{
                  backgroundColor: "var(--completed-background)",
                  borderRadius: 20,
                  padding: ".4rem .7rem",
                  marginTop: ".6rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    height: 7,
                    width: 7,
                    backgroundColor: "var(--completed-color)",
                    borderRadius: 50,
                  }}
                />
                <Text
                  style={{
                    color: " var(--completed-color)",
                    marginLeft: ".4rem",
                  }}
                  variant="xs"
                >
                  Active
                </Text>
              </div>
            )}
          </div>
          <Text tag="div">
            <img src={icons.logoIcon} alt="" />
          </Text>
        </Text>
      </Text>
      {visible && <CardModal setVisible={setVisible} cardId={cardId}/>}
    </Text>
  );
};
